import React, { useEffect, useState } from "react"
import axios from "axios"
import { Link, NavLink, useParams } from 'react-router-dom'
import Loader from "../components/Loader"
import * as Constants from '../components/Constants'
import Header from '../components/Header'
import Footer from '../components/Footer'

const Product = () => {
    const [loading, setLoading] = useState(true);
    const [product, setProduct] = useState({});
    const [brand, setBrand] = useState({});
    const params = useParams();

    useEffect(() => {
        axios.get(`${Constants.LARAVEL_API_URL}/getProduct/${params.product_slug}`).then(res => {
            if (res.data.status === 200) {
              setLoading(false)
              setProduct(res.data.product)
              setBrand(res.data.brand)
            }
        });
      }, [params]);


    const tabs = document.querySelectorAll('.tab_btn');
    const all_content = document.querySelectorAll('.content');

    tabs.forEach((tab, index) => {
        tab.addEventListener('click', (e) => {
            tabs.forEach(tab => {tab.classList.remove('active')});
            tab.classList.add('active')

            var line = document.querySelector('.line');
            line.style.width = e.target.offsetWidth + "px";
            line.style.left = e.target.offsetLeft + "px";

            all_content.forEach(content=>{content.classList.remove('active')})
            all_content[index].classList.add('active')
        })

        
    })

    return (
        <>
            <main>
                <Header />
                <div className="container">
                    <h1 className="commonTitle">{loading ? <Loader width={30} height={30} /> : product.name}</h1>
                    <div className="commonBreadcrumbs">
                        <ul>
                            <li><NavLink to="/"><i className="fa-solid fa-house-chimney"></i></NavLink></li>
                            /
                            <li><NavLink to="/catalog">Каталог продукции</NavLink></li>
                            /
                            <li>{product.name}</li>
                        </ul>
                    </div>
                    <div className="productOutput">
                        <div className="productGallery">
                            <figure>
                                <a href={`${Constants.LARAVEL_URL}/assets/images/products/${product.images}`} data-fancybox="group">
                                    <img src={`${Constants.LARAVEL_URL}/assets/images/products/${product.images}`} alt={product.name} />
                                </a>
                            </figure>
                        </div>
                        <div className="productContent">
                            <div className="productContentHead">
                                <div className="productContentHeadLeft">
                                    <h3>Код продукта: {product.SKU}</h3>
                                    <h3>Производитель: <Link to={`/brands/${brand.slug}`}>{brand.name}</Link></h3>
                                </div>
                                <div className="productContentHeadRight">
                                    <div className="headerHeadBtn">запросить <br />цену</div>
                                </div>
                            </div>
                            <hr></hr>
                            <div className="tab_box">
                                <button className="tab_btn active">Описание продукта</button>
                                <button className="tab_btn">Характеристики продукта</button>
                                <button className="tab_btn">Информация для заказа</button>
                                <div className="line"></div>
                            </div>
                            <div className="content_box">
                                <div className="content active">
                                    <div className="descrProduct" dangerouslySetInnerHTML={{ __html: product.description }}></div>
                                </div>
                                <div className="content">
                                    <div className="charProduct" dangerouslySetInnerHTML={{ __html: product.char }}></div>
                                </div>
                                <div className="content">
                                    <div className="infoProduct" dangerouslySetInnerHTML={{ __html: product.usage }}></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </main>
            <Footer />
        </>
    )
}

export default Product
